import { render, staticRenderFns } from "./QuestionarioLaboratorio.vue?vue&type=template&id=49d53200&scoped=true"
import script from "./QuestionarioLaboratorio.vue?vue&type=script&lang=js"
export * from "./QuestionarioLaboratorio.vue?vue&type=script&lang=js"
import style0 from "./QuestionarioLaboratorio.vue?vue&type=style&index=0&id=49d53200&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d53200",
  null
  
)

export default component.exports